// Shared by the Policy page and its tests; no DOM.

// ruleToWriteShape turns a rule as GET /v1/rules lists it (decision +
// constraint) into the shape both the daemon and the coordinator take
// on writes: policy.yaml's (forbid / require_confirm).
export function ruleToWriteShape(view) {
  const out = { name: view.name, reason: view.reason };
  // A listed rule without a constraint is one saved with no conditions;
  // send it as such (the server says why) rather than as {}, which would
  // match everything.
  out[view.decision === "require_confirm" ? "require_confirm" : "forbid"] =
    view.constraint === undefined ? null : view.constraint;
  if (view.decision === "require_confirm" && view.grace_seconds)
    out.grace_seconds = view.grace_seconds;
  if (view.mode === "audit") out.mode = "audit";
  if (view.unless) out.unless = view.unless;
  if (view.disabled) out.disabled = true;
  return out;
}
